export const CACHE_DURATION_DAYS = 1;
export const CACHE_DURATION_MS = CACHE_DURATION_DAYS * 24 * 60 * 60 * 1000;

export function isCacheFresh(savedAt: unknown, durationMs = CACHE_DURATION_MS): boolean {
  const timestamp = Number(savedAt || 0);
  return timestamp > 0 && Date.now() - timestamp < durationMs;
}

export function isCacheExpired(savedAt: unknown, durationMs = CACHE_DURATION_MS): boolean {
  return !isCacheFresh(savedAt, durationMs);
}
